import { Component } from '@angular/core';
import { MEBrick } from 'src/app/common/activities/me-meta';
import { TranslateService } from '@ngx-translate/core';
import { ResponsiveDesignService } from 'src/app/common/services/responsive-design/responsive-design.service';

@Component({
    selector: 'app-me-base',
    templateUrl: './me-base.component.html',
    styleUrls: ['./me-base.component.less'],
    standalone: false
})
export class MeBaseComponent {
  brick!: MEBrick;
  formControl!: any;

  constructor(public translate: TranslateService, protected srvRpDesign: ResponsiveDesignService) {}

  public configure(brick : MEBrick, formControl: any) : void {
    this.brick = brick;
    if (brick.isFormBrick) {
      this.setBrickAppearance();
      this.formControl = formControl;
      this.formControl.valueChanges.subscribe((val: any) => {

        setTimeout(() => {
          brick.value = val;
          this.updateComponentValue(val);  
        })
      })
    }

    this.onConfigurationComplete();
  }

  public onConfigurationComplete() {};
  public updateComponentValue(value : any) {};

  getErrorMessage() {
    let errStr: string = '';
    this.brick.validation?.forEach((v) => {

      if (this.formControl.hasError(v.getValidationType())) {
        errStr += v.getErrorMessage().trim();
        if (v.hasEndingPeriod) {
          errStr += ".";
        }
      }
    });
    return errStr;
  }

  private setBrickAppearance() {
    this.brick.appearance = this.srvRpDesign.getMatFormFieldAppearance();
  }
}
